module.exports = __webpack_public_path__ + "static/media/contacts.5807cffa.svg";